import PropTypes from 'prop-types'
import { useEffect } from 'react';

import { capitalize } from 'lodash';
import { ChevronDown } from 'lucide-react';
import { Button, DropdownMenu, InputGroup, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from 'twyne-new.ui'

import Input from '@Components/formsy/Input';

const propTypes = {
  data: PropTypes.object,
  onChange: PropTypes.func,
  origin: PropTypes.oneOf(['integration', 'page', 'path-page', 'profile', 'form-visibility', 'form-populate']),
  disabled: PropTypes.bool,
}

export default function RuleItemDate({ data, onChange }) {
  const { value } = data
  const { duration, unit } = value || {}

  const handleChange = (key, value) => {
    const update = { ...data.value, [key]: value }
    onChange({ ...data, value: update })
  }

  return <>
    <InputGroup className="w-100">
      <Input required name="date-rule-value" validationErrors={{ isRequired: '' }}
        value={duration} onChange={value => handleChange('duration', value)} />
      <Dropdown value={unit} onChange={value => handleChange('unit', value)} />
    </InputGroup>
  </>
}

function Dropdown({ value, onChange }) {
  useEffect(() => {
    if (!value) {
      onChange('days')
    }
  }, [value, onChange])

  return <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <Button color='accent'>
        {capitalize(value)}
        <ChevronDown size={16} />
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent>
      {OPTIONS.map(({ label, value }) => <DropdownMenuItem key={value} onClick={() => onChange(value)}>
        {label}
      </DropdownMenuItem>)}
    </DropdownMenuContent>
  </DropdownMenu>
}

const OPTIONS = [
  { label: 'Days', value: 'days' },
  { label: 'Weeks', value: 'weeks' },
  { label: 'Months', value: 'months' },
]

RuleItemDate.propTypes = propTypes
